import { Switch, Space } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

function SwitchField (props) {
  const { id, type, label, labelYes='Yes', labelNo='No', ...rest } = props;
  return (
    <Space>
        <div className="switch-field">
          <Switch id={id}
            className="custom-switch"
            checkedChildren={type === 'text' ? labelYes: <CheckOutlined />}
            unCheckedChildren={type === 'text' ? labelNo: <CloseOutlined />}
            {...rest}
          />
        </div>
        {label && 
          <label>{label}</label>
        }
    </Space>
    
  );
};

export default SwitchField;